export const styles = () => ({
  root: {},
  tabIcons: {
    width: "20px",
    height: "20px",
    margin: "0 !important",
    fill: "white",
  },
});
